import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/wareHousedistribute/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/wareHousedistribute/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/wareHousedistribute/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/wareHousedistribute/submit', params,options);

export const update = (params, options) =>
request.post('/api/wareHousedistribute/submit', params,options);
